import { GameRandom, Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import {
    BussinesTripModel,
    BussinesTripRouteA,
    BussinesTripRouteB,
    BussinesTripRouteType,
} from '../Models/BussinesTripModel';
import { BussinesTripMarkerModel } from '../Models/BussinesTripMarkerModel';

@Singleton
export class BussinesTripLogic {
    constructor(
        @Inject private _model: BussinesTripModel,
        @Inject private _modelEvents: ModelEvents,
        @Inject private _random: GameRandom) {
    }

    public reset(): void {
        this._model.routesCount = 3;
        this._model.routeIndex = -1;

        this._model.routes = [];
        this._model.selectedMarkers = [];
    }

    public setRouteType(routeType: BussinesTripRouteType): void {
        const routes = routeType === BussinesTripRouteType.A ? BussinesTripRouteA : BussinesTripRouteB;

        this._model.routes = Object.keys(routes).map(key => routes[key])
            .sort(() => Math.random() - 0.5)
            .slice(0, this._model.routesCount);

        this._model.routeIndex = 0;
        this._model.routeType = routeType;
        this._model.markers = [];

        Object.keys(routes).map(key => routes[key]).forEach(o => {
            o.split('_').forEach(name => {
                if (!this._model.markers.find(a => name === a)) {
                    this._model.markers.push(new BussinesTripMarkerModel(name));
                }
            });
        });
    }

    public nextRoute(): string {
        if (this._model.routes.shift()) {
            this._model.routeIndex++;
            this._model.selectedMarkers = [];

            return this.getCurrentRoute();
        }

        return null;
    }

    public clearSelectedCities(): void {
        this._model.selectedMarkers = [];
    }

    public getCurrentRoute(): string {
        return this._model.routes.length > 0 ? this._model.routes[0] : null;
    }

    public onCitySelect(model: BussinesTripMarkerModel): void {
        this._model.selectedMarkers.push(model);
    }

    public onCityDeselect(model: BussinesTripMarkerModel): void {
        this._model.selectedMarkers.splice(this._model.selectedMarkers.indexOf(model), 1);
    }

    public isCitySelected(model: BussinesTripMarkerModel): boolean {
        return this._model.selectedMarkers.indexOf(model) > -1;
    }

    public getSelectedCities(): Array<BussinesTripMarkerModel> {
        return this._model.selectedMarkers;
    }

    public getCitiesPattern(): string {
        const cities = this.getSelectedCities();

        if (cities.length === 2) {
            const a = cities[0];
            const b = cities[1];
            const pattern = a.name + '_' + b.name;

            return pattern;
        }

        return null;
    }

    public getCitiesInversePattern(): string {
        const cities = this.getSelectedCities();

        if (cities.length === 2) {
            const a = cities[0];
            const b = cities[1];
            const pattern = b.name + '_' + a.name;

            return pattern;
        }

        return null;
    }

    public getRouteByPattern(): string {
        const route = this.getCurrentRoute();

        const pattern = this.getCitiesPattern();
        const inversePattern = this.getCitiesInversePattern();

        if (route === pattern || route === inversePattern) {
            return route;
        }

        return null;
    }

    public isMatch(): boolean {
        const pattern = this.getCitiesPattern();
        const inversePattern = this.getCitiesInversePattern();

        if (pattern || inversePattern) {
            const route = this.getCurrentRoute();
            const isMatch = route === pattern || route === inversePattern;

            return isMatch;
        }

        return false;
    }
}
